import React from 'react';
import { NavLink } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import SiteContentContext from '../../content/SiteContentContext';
import { getTranslations, getByPath, resolveMediaSrc } from '../../content/siteContentUtils';

const defaultSliderImages = [
    require('./../../images/about-slider/1.jpg'),
    require('./../../images/about-slider/2.jpg'),
    require('./../../images/about-slider/3.jpg'),
    require('./../../images/about-slider/4.jpg')
];
const defaultBeforeImage = require('./../../images/about-slider/1-ab.jpg');

var bgimg1 = require('./../../images/background/bg-4.png');
var bgimg2 = require('./../../images/background/cross-line2.png');

class About1 extends React.Component {
    static contextType = SiteContentContext;

    render() {
        const options = {
            loop: true,
            autoplay: true,
            margin: 30,
            nav: true,
            dots: true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            responsive: {
                0: { items: 1 },
                991: { items: 1 }
            }
        };

        const content = this.context?.content || {};
        const t = getTranslations(content);
        const aboutBanner = t?.pages?.about?.banner || {};
        const aboutIntro = t?.pages?.about?.intro || {};
        const mediaSliderImages = getByPath(content, 'media.pages.homeAboutSliderImages', []);
        const sliderImages = defaultSliderImages.map((fallbackImage, index) => {
            const mediaItem = Array.isArray(mediaSliderImages) ? mediaSliderImages[index] : null;
            const imageUrl = typeof mediaItem === 'string' ? mediaItem : mediaItem?.imageUrl;
            return resolveMediaSrc(imageUrl, fallbackImage);
        });
        const beforeImage = resolveMediaSrc(getByPath(content, 'media.pages.homeAboutBeforeImage', ''), defaultBeforeImage);

        return (
            <>
                <div className="section-full mobile-page-padding p-t80 p-b80 bg-white bg-no-repeat bg-bottom-left" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                    <div className="container">
                        <div className="section-head">
                            <div className="sx-separator-outer separator-left">
                                <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + bgimg2 + ')' }}>
                                    <h3 className="sep-line-one">{aboutBanner.title || 'Hakkımızda'}</h3>
                                </div>
                            </div>
                        </div>
                        <div className="section-content">
                            <div className="row">
                                <div className="col-lg-5 col-md-12 col-sm-12">
                                    <div className="about-home-left">
                                        <h3 className="m-t0 sx-tilte">{aboutIntro.title || ''}</h3>
                                        <p>{aboutIntro.description || ''}</p>
                                        <div className="text-left">
                                            <NavLink to="/hakkimizda" className="site-button-secondry btn-half"><span>{aboutIntro.buttonLabel || 'Devamını Oku'}</span></NavLink>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-7 col-md-12 col-sm-12">
                                    <div className="about-home-right">
                                        <OwlCarousel className="owl-carousel about-home number-slider owl-btn-vertical-center" {...options}>
                                            {sliderImages.map((item, index) => (
                                                <div className="item" key={index}>
                                                    <div className="sx-img-effect zoom-slow">
                                                        <NavLink to={'/hakkimizda'}><img src={item} alt="" /></NavLink>
                                                    </div>
                                                </div>
                                            ))}
                                        </OwlCarousel>
                                        <div className="about-home-before">
                                            <img src={beforeImage} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default About1;
